import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "6",
  fill: "none",
  viewBox: "0 0 10 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M1.429 0 5 3.75 8.571 0 10 .75 5 6 0 .75z"
    }, null, -1)
  ])))
}
export default { render: render }